"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compositionsCleanTabs = require("@eig-builder/compositions-clean-tabs");

var _Tab = _interopRequireDefault(require("@eig-builder/core-ui/Tab"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _comboBox = _interopRequireDefault(require("../combo-box"));

var _dataGridContext = require("../../../data-grid-context");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  max-height: 63px !important;\n  height: 63px !important;\n\n  span {\n    font-weight: normal;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  left: 0;\n  top: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CustomTabsPositionWrapper = _styledComponents["default"].div(_templateObject());

var CustomHeightTab = (0, _styledComponents["default"])(_Tab["default"])(_templateObject2());

var TabsImplementation = function TabsImplementation(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      defaultValue = _ref.defaultValue,
      tag = _ref.tag;

  var _useDataGridContext = (0, _dataGridContext.useDataGridContext)(),
      filters = _useDataGridContext.filters,
      setFilters = _useDataGridContext.setFilters;

  var value = options.find(function (x) {
    return x.key === filters.key;
  });
  return /*#__PURE__*/_react["default"].createElement(_comboBox["default"], {
    onChange: function onChange(value) {
      return setFilters(value);
    },
    value: filters || options.find(function (f) {
      return f["default"];
    }) || defaultValue
  }, /*#__PURE__*/_react["default"].createElement(CustomTabsPositionWrapper, null, /*#__PURE__*/_react["default"].createElement(_compositionsCleanTabs.Tabs, {
    value: value,
    onChange: function onChange(r, i) {
      setFilters(i);
    }
  }, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(CustomHeightTab, {
      key: option.key,
      value: option,
      label: option.key,
      dataElementLocation: _taggingHelper.DataElementLocations.POP_UP,
      dataElementLabel: "".concat(tag, "-").concat(option.key),
      dataElementId: "".concat(tag, "-").concat(option.key)
    });
  }))));
};

TabsImplementation.propTypes = {
  options: _propTypes["default"].array.isRequired,
  tag: _propTypes["default"].string.isRequired,
  defaultValue: _propTypes["default"].any
};
var _default = TabsImplementation;
exports["default"] = _default;